var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.type,"loading":_vm.processing,"disabled":_vm.disabled,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle,"icon":_vm.icon,"autofocus":_vm.autofocus},on:{"click":_vm.__submit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f44deba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/widgets/submit-btn.vue
// module id = null
// module chunks = 